/*eslint-disable*/
import React, { useState, useEffect, useContext } from "react";
import { useHistory, useParams } from "react-router-dom";
import { useOktaAuth } from "@okta/okta-react";
import useFetch from "../../_helpers/useFetch";
import { CPContext } from "../../_helpers/CPContext";
import useUtilities from "../../_helpers/useUtilities";
import { Card } from "react-bootstrap";
import { config } from "config";
import { Spinner } from "_components/shared/Common";


type propType = {
    policyDWKey: string;
    formNumber: string;
};

const PolicySurrenderForm: React.FC = () => {
    const params = useParams<propType>();
    let idParsed = 0;
    let formNumberParsed = "";

    if (
        typeof params.policyDWKey != "undefined" &&
        params.policyDWKey &&
        params.policyDWKey.trim()
    ) {
        idParsed = +params.policyDWKey;
    }
    const navigate = useHistory();
    const search = navigate.location.search;
    const paramsFromURL = new URLSearchParams(search);
    formNumberParsed = paramsFromURL.get("formNumber") ?? "details";

    const cpContext = useContext(CPContext);
    const utilities = useUtilities();
    const { get } = useFetch();
    const { authState } = useOktaAuth();
    const [errorMessage, setErrorMessage] = useState("");
    const [policyData, setPolicyData] = useState<Policy>();
    const [isProcessing, setIsProcessing] = useState(false);

    useEffect(() => {
        const getPolicy = async () => {
            console.log(config.app.docuSignUri);
            try {
                setIsProcessing(true);
                const policyFromServer = await get<Policy>(
                    "/policy/full?policyDWKey=" + idParsed,
                    ""
                );
                setPolicyData(policyFromServer);

                setIsProcessing(false);
            } catch (e: unknown) {
                if (utilities.isMaintenanceError(e)) {
                    navigate.push("/maint");
                } else {
                    setErrorMessage(
                        "There was a problem loading your policy information, please call us at " +
                        utilities.getSupportPhoneNumberByCompanyCode(
                            policyData?.companyCode ?? 0
                        ) +
                        " for assistance."
                    );
                    setIsProcessing(false);
                }
            }
        };

        if (
            authState &&
            authState.isAuthenticated &&
            cpContext.sessionId &&
            cpContext.sessionId.length > 0
        ) {
            getPolicy();
        }
    }, [authState, cpContext, navigate]);

    if (policyData && errorMessage.length <= 0) {
        return (
            <section aria-labelledby="form-download-section">
                <h2 style={{ display: "none" }} aria-labelledby="form-download-section">
                    Form Download Section
                </h2>
                <div className="row" style={{ backgroundColor: "#eee", padding: "20px" }}>
                    <div className="col-md-12">
                        <div
                            className="row"
                            style={{
                                paddingTop: 10,
                                paddingBottom: 0,
                                borderTop: 0,
                                borderLeft: 0,
                                borderRight: 0,
                                borderBottom: 2,
                                borderStyle: "solid",
                                borderColor: "#33CCCC"
                            }}
                        >
                            <div className="col-6">
                                <h1 className="custom-h1 skip-to" style={{ paddingTop: 10 }}>
                                    Policy Surrender
                                </h1>
                            </div>
                            <div className="col-6">
                                <div style={{ paddingTop: 10 }}>
                                    Policy # {policyData?.policyNumber} - {policyData?.product}
                                </div>
                            </div>
                        </div>
                        <div className="row" style={{ padding: 10 }}>
                            <div className="col-12">
                                <Card className="policyCard">
                                    <Card.Body className="shadow">
                                        <>
                                            <div>
                                                <div
                                                    className="row"
                                                    style={{ paddingTop: 5, paddingBottom: 15 }}
                                                >
                                                    <div id="sectionHeading" className="col-12" tabIndex={0} >
                                                        <p>
                                                            Click below to electronically complete, sign and submit your surrender form.
                                                            <br></br>
                                                            <br></br>
                                                            <a href={config.app.docuSignUri} target="_blank">Complete Form</a><br></br>
                                                            <br></br>
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </>
                                    </Card.Body>
                                </Card>
                            </div>
                        </div>
                        <div className="row pt-3 ps-2">
                            <div className="col-12">
                                <div className="row">
                                    <>
                                        <div className="col-4">
                                            <input
                                                type="button"
                                                className="btn btn-Primary"
                                                onClick={() =>
                                                    navigate.push(
                                                        "/policy-detail/" +
                                                        idParsed +
                                                        "?tab=service"
                                                    )
                                                }
                                                value="Cancel"
                                                aria-label="Cancel button"
                                            ></input>
                                        </div>
                                    </>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        );
    } else if (isProcessing) {
        return (
            <section aria-labelledby="form-download-section">
                <h1 style={{ display: "none" }}>Form Download Spinner</h1>
                <h2 style={{ display: "none" }} aria-labelledby="form-download-section">
                    Form Download Section
                </h2>
                <Spinner imageWidth={20} aria-label="Loading" />
            </section>
        );
    } else {
        return (
            <section aria-labelledby="form-download-section">
                <h1 style={{ display: "none" }}>Form Download Contact Customer Service</h1>
                <h2 style={{ display: "none" }} aria-labelledby="form-download-section">
                    Form Download Section
                </h2>
                <div className="d-flex flex-column min-vh-100 justify-content-center align-items-center">
                    Could not load selected form, please contact customer service for assistance.
                    <br></br>
                    <br></br>
                    <input
                        type="button"
                        value="Back"
                        className="btn btn-Primary"
                        onClick={() => navigate.push("/policy-detail/" + idParsed + "?tab=service")}
                        style={{ width: "90px" }}
                        aria-label="Back button"
                    ></input>
                </div>
            </section>
        );
    }

};

export default PolicySurrenderForm;
/*eslint-enable*/
